<template>
  <v-layout
    v-if="whitelabelStats" 
    wrap
  >
    <v-flex
      xs12
    >
      <template>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left" />
                <th class="text-left">
                  {{ $t('traderdashboard.today') }}
                </th>
                <th class="text-left">
                  {{ $t('traderdashboard.thisMonth') }}
                </th>
                <th class="text-left">
                  {{ $t('traderdashboard.total') }}
                </th>
              </tr>
            </thead>
            <tbody class="text-no-wrap">
              <tr>
                <td>{{ $t('traderdashboard.revenue') }}</td>
                <td><b>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue.today }}</b></td>
                <td><b>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue.this_month }}</b></td>
                <td><b>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue.total }}</b></td>
              </tr>
              <tr>
                <td>{{ $t('traderdashboard.revenueSubscription') }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_subscription.today }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_subscription.this_month }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_subscription.total }}</td>
              </tr>
              <tr>
                <td>{{ $t('traderdashboard.revenueTrading') }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_trading.today }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_trading.this_month }}</td>
                <td>{{ 'USD' | renderSymbol }} {{ whitelabelStats.revenue_trading.total }}</td>
              </tr>
              <tr>
                <td>{{ $t('traderdashboard.users') }}</td>
                <td>{{ whitelabelStats.users.today }}</td>
                <td>{{ whitelabelStats.users.this_month }}</td>
                <td>{{ whitelabelStats.users.total }}</td>
              </tr>
              <tr>
                <td>{{ $t('traderdashboard.linkedAccounts') }}</td>
                <td>{{ whitelabelStats.connections.today }}</td>
                <td>{{ whitelabelStats.connections.this_month }}</td>
                <td>{{ whitelabelStats.connections.total }}</td>
              </tr>
              <tr>
                <td>{{ $t('traderdashboard.deposits') }}</td>
                <td class="pt-4">
                  <span
                    v-for="(d, i) in whitelabelStats.deposits.today"
                    :key="i"
                  >
                    {{ d.currency | renderSymbol }} {{ d.amount }}<br>
                  </span>
                </td>
                <td class="pt-4">
                  <span
                    v-for="(d, i) in whitelabelStats.deposits.this_month"
                    :key="i"
                  >
                    {{ d.currency | renderSymbol }} {{ d.amount }}<br>
                  </span>
                </td>
                <td class="pt-4">
                  <span
                    v-for="(d, i) in whitelabelStats.deposits.total"
                    :key="i"
                  >
                    {{ d.currency | renderSymbol }} {{ d.amount }}<br>
                  </span>
                </td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
    </v-flex>
  </v-layout>
</template>

<script>

export default {
  name: 'StatsTable',
  props: {
    whitelabelStats: {
      type: Object,
      default: null
    },
  },
 
  data: () => ({
    loading: false,
  }),
  methods: {
    
  },
}
</script>